import { render, staticRenderFns } from "./DocumentosReferencias.vue?vue&type=template&id=c4093998"
import script from "./DocumentosReferencias.vue?vue&type=script&lang=js"
export * from "./DocumentosReferencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports